import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';

import { DataTable } from '../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../IAdminPageProperties';
import { TagCategoryAdminDomain } from './store/TagCategoryAdminDomain';

export interface ITagCategoryAdminTableProperties extends IAdminPageProperties { }

export const TagCategoryAdminTable = observer(({ layoutDomain }: ITagCategoryAdminTableProperties) => {
  useEffect(() => {
    layoutDomain.ui.pagePadding.setValue(0)
    return () => layoutDomain.ui.pagePadding.setValue(24)
  }, [])
  const [domain] = useState<TagCategoryAdminDomain>(new TagCategoryAdminDomain(layoutDomain));

  return <DataTable dataTableDomain={domain} tableHeight={window.innerHeight} />;
});
